<button [matMenuTriggerFor]="menu" class="btn btn-icon btn-transparent"><span class="material-icons-outlined">menu</span></button>
<mat-menu #menu="matMenu">
    <button *ngIf="showCacheClearBtn" (click)="clearCacheAndReload()" mat-menu-item>Clear cache and reload</button>
    <a mat-menu-item [href]="logoutUrl">Logout</a>
</mat-menu>